<template>
  <div :key="`list-item-${index}`">
    <jade-list-item
      navigation
      :label="$t(source.serial_number)"
      :description="source.created_at | dateFormat(crateAtFormat)"
      :third-line="source?.store?.name"
      @onClick="handleClick(source.serial_number, 'terminalDetails')"
    >
      <template slot="trailing">
        <div class="flex flex-col items-end">
          <jade-text color="medium">
            {{ source?.serial_number }}
          </jade-text>
          <div class="mt-1">
            <jade-tag
              size="medium"
              :variant="statusTag(source.status)"
            >
              {{ $t(source.status) }}
            </jade-tag>
          </div>
        </div>
      </template>
    </jade-list-item>

    <div
      v-if="!hasLastItem"
      class="px-5"
    >
      <jade-divider />
    </div>
  </div>
</template>

<script>
import physicalWorldListItemMixin from '../physical-world-list-item.mixin'
import { CREATED_AT } from './terminals-list.fields'

export default {
  name: 'TerminalsListItem',
  mixins: [physicalWorldListItemMixin],
  data () {
    return {
      crateAtFormat: CREATED_AT.format
    }
  }
}
</script>

<i18n src="../physical-world-status.locale.json"></i18n>
